import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../components/Header";

// Icons
import PadelBoxLogoBlack from "../../assets/images/padelbox_logo_quadrado_dark.svg";
import FacebookLogo from "../../assets/images/facebook_logo.svg";
import InstagramLogo from "../../assets/images/instagram_logo.svg";
import YoutubeLogo from "../../assets/images/youtube_logo.svg";
import SpotifyLogo from "../../assets/images/spotify_logo.svg";
import IosCallOutline from "react-ionicons/lib/IosCallOutline";
import IosMailOutline from "react-ionicons/lib/IosMailOutline";
import IosGlobeOutline from "react-ionicons/lib/IosGlobeOutline";

// CSS Files
import './styles.css';

const About = () => {
   const { t } = useTranslation();

   return <div>
      <Header headerBarTitle={t("about_us_page.header")}/>
      <Container className={"desktop"}>
         <Row className={"mt-5 mb-5"}>
            <Col className={"text-center"}>
               <img width={150} src={PadelBoxLogoBlack}/>
            </Col>
         </Row>

         <Row className={"pb-3"}>
            <Col xs={11} className={"mx-auto"}>
               <a href={"tel:935137520"} className={"phone-card pl-2 color-green font-weight-bold link"}>
                  <IosCallOutline fontSize="25px" color={"#AFFF55"} className={"mr-2"}/>
                  (+351) 935 137 520
               </a>
            </Col>
         </Row>

         <Row className={"pb-3"}>
            <Col xs={11} className={"mx-auto"}>
               <a href={"mailto:geral@padelbox.pt"} className={"font-weight-bold link"}>
                  <IosMailOutline fontSize="25px" color={"#AFFF55"} className={"mr-2"}/>
                  geral@padelbox.pt
               </a>
            </Col>
         </Row>

         <Row className={"mb-5"}>
            <Col xs={11} className={"mx-auto"}>
               <a href={"https://www.padelbox.pt"} target={"_blank"} rel="noopener" className={"font-weight-bold link"}>
                  <IosGlobeOutline fontSize="25px" color={"#AFFF55"} className={"mr-2"}/>
                  www.padelbox.pt
               </a>
            </Col>
         </Row>

         <Row>
            <Col className={"d-flex justify-content-center mx-auto"}>
               <a href={"https://www.facebook.com/ligaspadelbox"} target={"_blank"}>
                  <img src={FacebookLogo} alt={"facebook logo"} className={"mr-3 social"}/>
               </a>
               <a href={"https://www.instagram.com/ligapadelbox/"} target={"_blank"}>
                  <img src={InstagramLogo} alt={"instagram logo"} className={"mr-3 social"}/>
               </a>
               <a href={"https://www.youtube.com/ForumPadel"} target={"_blank"}>
                  <img src={YoutubeLogo} alt={"youtube logo"} className={"mr-3 social"}/>
               </a>
               <a href={"https://open.spotify.com/show/58z6Hr41Dcxs1tCABsnr3J?si=RKVQIOPrRCSG_VBdE2i11Q&nd=1"} target={"_blank"}>
                  <img src={SpotifyLogo} alt={"spotify logo"} className={"social"}/>
               </a>
            </Col>
         </Row>
      </Container>
   </div>
};

export default About;